module.exports = __webpack_public_path__ + "55d15529888cfcb15cb52b8b93ad2f1b.svg";